import { useGetStatisticsQuery } from 'api/StatisticsEndPoints';
import TopAreas from 'modules/Dashboard/TopAreas';

import AverageTimeSpentMetric from 'modules/Dashboard/AverageTimeSpentMetric';
import ConnectionMetric from 'modules/Dashboard/ConnectionMetric';
import TopConfigs from 'modules/Dashboard/TopConfigs';
import TopRevisitTimes from 'modules/Dashboard/TopRevisitTimes';
import TopUsersMetric from 'modules/Dashboard/TopUsersMetric';
import UserCountMetric from 'modules/Dashboard/UserCountMetric';
import Loader from 'shared/component/Loader';
import Metric from 'shared/routes/components/Metric/Metric';
import './dashboard.css';

const Dashboard = () => {
  const { data, isLoading } = useGetStatisticsQuery();

  return (
    <div>
      <div className="page-title">Global Dashboard</div>
      <div className="page-subtitle">
        Below you will find the main indicators on the use of the application:
      </div>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="metrics">
          <ConnectionMetric stats={data} />
          <UserCountMetric />
          <AverageTimeSpentMetric stats={data} />
          <TopRevisitTimes stats={data} />
          <Metric label="Top 5 Areas of Interests">
            <TopAreas stats={data} />
          </Metric>
          {data && <TopUsersMetric stats={data} />}
          <Metric label="Top 5 Configurations">
            <TopConfigs stats={data} />
          </Metric>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
